<avi-data-grid
    [config]="rulesGridConfig"
    [rows]="rules.config"
    (onRowOrderChange)="handleRowReorder($event)"
    gridTitle="{{ l10nKeys.rulesGridTitle | vtranslate : rules.count }}"
>
    <avi-data-grid_actions>
        <cds-button
            (click)="addRule()"
            size="sm"
        >
            {{ l10nKeys.addButtonLabel | vtranslate }}
        </cds-button>
    </avi-data-grid_actions>
    <ng-template
        #enabledColumnTemplateRef
        let-row
    >
        <cds-icon
            *ngIf="row.config.enable"
            status="success"
            shape="check-circle"
            size="18"
        ></cds-icon>
    </ng-template>
    <ng-template
        #expandedContentTemplateRef
        let-row
    >
        <match-and-action-display-wrapper>
            <match-and-action-display-wrapper_match-content>
                <ip-addr-match-readonly
                    *ngIf="row.config.match.config.client_ip"
                    [editable]="row.config.match.config.client_ip"
                ></ip-addr-match-readonly>
                <ip-reputation-type-match-readonly
                    *ngIf="row.config.match.config.ip_reputation_type"
                    [editable]="row.config.match.config.ip_reputation_type"
                ></ip-reputation-type-match-readonly>
                <port-match-readonly
                    *ngIf="row.config.match.config.vs_port"
                    [editable]="row.config.match.config.vs_port"
                ></port-match-readonly>
            </match-and-action-display-wrapper_match-content>

            <match-and-action-display-wrapper_action-content>
                <span>{{ row.ruleActionText }}</span><br>
                <span *ngIf="row.config.action ===
                    networkSecurityPolicyActionType.NETWORK_SECURITY_POLICY_ACTION_TYPE_RATE_LIMIT"
                >
                    {{ row.rateLimitActionText }}
                </span>
            </match-and-action-display-wrapper_action-content>
        </match-and-action-display-wrapper>
    </ng-template>
</avi-data-grid>
